<template>
    <div class="ListCard">
        <ul class="List flex flex-wrap">
            <li
                v-for="({ label, icon, path, name, params }) in items"
                :key="path"
                class="Item"
            >
                <a
                    href="#"
                    class="Link flex col-center"
                    :title="label"
                    @click.prevent="$emit('onClick', { name, params })"
                >
                    <WIcon
                        :icon="icon"
                        :size="48"
                    />
                    <WText
                        weight="semi"
                        align="center"
                        class="mt-1 pl-1 pr-1"
                    >
                        {{ label }}
                    </WText>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
import VueTypes from 'vue-types'

export default {
    name: 'ListCard',
    props: {
        items: VueTypes.arrayOf(VueTypes.shape({
            icon: VueTypes.string,
            path: VueTypes.string,
            name: VueTypes.string,
            label: VueTypes.string,
        }).loose),
    },
}
</script>
<style lang="scss" scoped>
.ListCard {
    .List {
        margin: -30px 0 0 -30px;
        padding: 0;
        list-style: none;
    }

    .Item {
        width: calc(50% - 30px);
        max-width: 300px;
        margin: 30px 0 0 30px;
        background: $card-bg;

        @media screen and (min-width: $md) {
            width: calc(33.33% - 30px);
        }

        @media screen and (min-width: $lg) {
            width: calc(25% - 30px);
        }
    }

    .Link {
        width: 100%;
        min-height: 180px;
        border: 1px solid $gray-05;
        border-radius: $border-radius;
        text-align: center;
        transition: all 350ms ease;

        .WIcon {
            color: $primary;
        }

        &:hover {
            background-color: rgba($primary, .1);
        }
    }
}
</style>
